import React from "react";
import PropTypes from "prop-types";
import CompanyOrIndividualData from "./CompanyOrIndividualData";
import USCompanyData from "./USCompanyData";
import ContactInfo from "./ContactInfo";
import ClientSoleTraderFeatureContainer from "./ClientSoleTraderFeatureContainer";
import useUserData from "hooks/useUserData";

function CreateClient({
  selectedClientLens,
  basicPartnerSearchType,
  isCompany,
  isSoleTraderFeature,
  validation,
  onBack,
}) {
  const { allowSoleTraderSearch } = useUserData();

  return (
    <>
      {allowSoleTraderSearch ? (
        <ClientSoleTraderFeatureContainer
          selectedClientLens={selectedClientLens}
          isSoleTraderFeature={isSoleTraderFeature}
          validation={validation}
          onBack={onBack}
        />
      ) : (
        basicPartnerSearchType !== -1 && (
          <CompanyOrIndividualData
            selectedClientLens={selectedClientLens}
            isCompany={isCompany}
            validation={validation}
            onBack={onBack}
          />
        )
      )}
      {isCompany && basicPartnerSearchType === -1 && (
        <USCompanyData selectedClientLens={selectedClientLens} onBack={onBack} />
      )}
      {basicPartnerSearchType === -1 && <ContactInfo selectedClientLens={selectedClientLens} onBack={onBack} />}
    </>
  );
}

CreateClient.propTypes = {
  selectedClientLens: PropTypes.object.isRequired,
  basicPartnerSearchType: PropTypes.string.isRequired,
  isCompany: PropTypes.bool.isRequired,
  isSoleTraderFeature: PropTypes.bool.isRequired,
  validation: PropTypes.object.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default CreateClient;
